




<template>
  <v-dialog persistent scrollable v-model="modals.info" width="850">
  <v-card>
    <v-toolbar dark  color="#4A76A8" flat  height="42">
      <v-toolbar-title  >   {{selected.title}} </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-icon @click=" modals.info = false">mdi-close</v-icon>
    </v-toolbar>

  <v-card-text>






    <v-data-table

          no-data-text="На данный момент нет сохраненных процессов"
          :headers="headers"
          :items="desserts"
          item-key="name"
          hide-actions
          class="elevation-1"
        >
          <template slot="items" slot-scope="props"   >
        <tr>
          <td>{{ props.item.name }}</td>
          <td class="text-xs-left">{{ props.item.max }}</td>
          <td class="text-xs-left">{{ props.item.counter }}</td>
          <td class="text-xs-left"> <span v-if="props.item.limit > 0">{{ props.item.limit  }}</span><span v-else >Нет</span></td>

          <td class="text-xs-left">
            <span v-if="props.item.expire">
            {{ props.item.expire | dateFormat}}
          </span>

            <span v-else>
              Нет
            </span>


          </td>




        </tr>
      </template>

    </v-data-table>













  </v-card-text>


  </v-card>
  </v-dialog>
</template>

<script>

import axios from 'axios'

export default {

props:['modals','selected','selectedLimits'],
  data () {
    return {
      search: '',
      headers: [
        {
          text: 'Название',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Максимальный лимит', value: 'max',sortable: false,  },
        { text: 'Счетчик', value: 'counter',sortable: false, },
        { text: 'Персональный лимит', value: 'limit',sortable: false, },
        { text: 'Лимит на действие до', value: 'expire',sortable: false, },
      ],
      desserts: [],


    }
  },
methods:{

},
created(){

 let data =   [
         {
           name: 'Сообщения',
           max:   this.selectedLimits.messageSend.max,
           limit: this.selectedLimits.messageSend.limit,
           counter: this.selectedLimits.messageSend.counter,
           expire: this.selectedLimits.messageSend.expire,
         },
         {
           name: 'Заявки в друзья',
           max: this.selectedLimits.friendRequest.max,
           limit: this.selectedLimits.friendRequest.limit,
           counter: this.selectedLimits.friendRequest.counter,
           expire: this.selectedLimits.friendRequest.expire,
         },
         {
           name: 'Посты',
           max: this.selectedLimits.postSend.max,
           limit: this.selectedLimits.postSend.limit,
           counter: this.selectedLimits.postSend.counter,
           expire: this.selectedLimits.postSend.expire,
         },
         {
           name: 'Комментария',
           max: this.selectedLimits.commentSend.max,
           limit: this.selectedLimits.commentSend.limit,
           counter: this.selectedLimits.commentSend.counter,
           expire: this.selectedLimits.commentSend.expire,
         },
         {
           name: 'Создания обсуждений',
           max: this.selectedLimits.topicCreate.max,
           limit: this.selectedLimits.topicCreate.limit,
           counter: this.selectedLimits.topicCreate.counter,
           expire: this.selectedLimits.topicCreate.expire,
         },
         {
           name: 'Комментария обсуждений',
           max: this.selectedLimits.topicComment.max,
           limit: this.selectedLimits.topicComment.limit,
           counter: this.selectedLimits.topicComment.counter,
           expire: this.selectedLimits.topicComment.expire,
         },
         {
           name: 'Лайки',
           max: this.selectedLimits.addLike.max,
           limit: this.selectedLimits.addLike.limit,
           counter: this.selectedLimits.addLike.counter,
           expire: this.selectedLimits.addLike.expire,
         },
         {
           name: 'Вступление в сообщества',
           max: this.selectedLimits.getInPublic.max,
           limit: this.selectedLimits.getInPublic.limit,
           counter: this.selectedLimits.getInPublic.counter,
           expire: this.selectedLimits.getInPublic.expire,
         },

       ]
 this.desserts = data


},
filters:{

  dateFormat(item){
    var months = ['Янв.','Фев.','Мар.','Апр.','Мая','Июнь.','Июль.','Авг.','Сен.','Окт.','Ноя.','Дек.'];

    let d =  new Date(item * 1000)

    return  d.getDate()+" "+months[d.getMonth()]+"  "+ d.getHours() +":"+ d.getMinutes()
  }
},
}
</script>

<style   >

</style>
